import Form from './SliderImageForm'
import isEmpty from './SliderImageIsEmpty'
import Section from './SliderImageSection'
import Thumbnail from './SliderImageThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
